import { EditIcon } from "lucide-react";
import { useState } from "react";
import { DialogTrigger } from "react-aria-components";

import { Button } from "../button";

import "@uppy/core/css/style.min.css";
import "@uppy/dashboard/css/style.min.css";
import { Modal, ModalHeading } from "../modal";
import { Uploader, type UploaderProps } from "./uploader";

export type UploadImageModalProps = Pick<
  UploaderProps,
  "bucket" | "prefix" | "onUploadSuccess"
>;

export function UploadImageModal(props: UploadImageModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
      <Button
        variant="icon"
        className="absolute top-3 right-3"
        tooltip="Edit Image"
      >
        <EditIcon />
      </Button>
      <Modal>
        <div className="flex flex-col space-y-8 p-3">
          <ModalHeading>Upload Image</ModalHeading>

          <Uploader {...props} onCancel={() => setIsOpen(false)} />
        </div>
      </Modal>
    </DialogTrigger>
  );
}
